/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import deepEqual from "deep-equal";
import MultiplayerTooltip from "../widgets/MultiplayerTooltip";

const MultiplayerTooltipManager = React.memo(({ ...otherAttributes }) => {
    const playerID = useSelector((state) => state.user.data.socketId);
    const players = useSelector(
        (state) => state.room.participants,

        (s1, s2) => deepEqual(Object.keys(s1), Object.keys(s2)),
    );
    const oldPlayers = React.useRef();

    const playerIDs = Object.keys(players).filter((x) => x !== playerID);

    const renderTooltip = () => {
        if (!oldPlayers.current) oldPlayers.current = {};

        const diffMultiplayerTooltip = playerIDs
            .filter((x) => {
                return x !== playerID && !Object.keys(oldPlayers.current).includes(x);
            })
            .map((x) => ({ 
                id: players[x].socketId,
                name: players[x].username,
                role: players[x].role,
                status: 1 
            }))
            .concat(
                Object.keys(oldPlayers.current)
                    .filter((x) => {
                        return x !== playerID && !playerIDs.includes(x);
                    })
                    .map((x) => ({
                        id: oldPlayers.current[x].socketId,
                        name: oldPlayers.current[x].username,
                        role: oldPlayers.current[x].role,
                        status: 0,
                    })),
            );
            
        oldPlayers.current = players;

        if (diffMultiplayerTooltip) {
            return diffMultiplayerTooltip.map((player, id) => {
                if (player.id !== playerID) {
                    return (
                        <MultiplayerTooltip
                            key={player.id}
                            playerName={player.name}
                            status={player.status}
                            role={player.role}
                            width={1}
                            height={0.12}
                            position={`0 ${0.70 - id * 0.1} -1`}
                        />
                    );
                }
                return null;
            });
        }
    };

    return (
        <a-entity class="MultiplayerTooltip" {...otherAttributes}>
            {renderTooltip()}
        </a-entity>
    );
});

export default MultiplayerTooltipManager;
